import logo from './logo.svg';
import './App.css';
import HeroSection from './screens/FirstScreen';
import NavBarNew from './components/CourseNav/NavBarNew';
import PlayerColumns from './components/columns/Columns';
import LogoCarousel from './components/logos/Logos';
import AboutMe from './components/me/Me';
import SecondScreen from './screens/SecondScreen';
import ByMe from './components/ByMe/ByMe';
import ThirdScreen from './screens/ThirdScreen';
import TestimonialsMessages from './components/testimonials/Testimonials';
import { FAQSection } from './screens/ForthScreen';
import ExitIntentPopup from './components/exitpopup/ExitPopup';
import FloatingWhatsAppButton from './components/FloatingButton/FloatingButton';
import PrivacyPolicy from './components/privacy/Privacy';

const Wrapper=()=> {
  return <>
  <NavBarNew/>
  <HeroSection/>
  <PlayerColumns/>
   <AboutMe/>
  <SecondScreen/>
 
    <LogoCarousel/>
    <TestimonialsMessages/>

<ThirdScreen/>
<FAQSection/>
<FloatingWhatsAppButton/>
    <PrivacyPolicy 
                      ownerName="קרן אקסלרוד - המשרד" 
                      email="Kerenaxelrod@gmail.com" 
                      phone="+972 50-891-9747" 
                      domain="https://hamisrad.co.il/" 
                    />
{/* <ExitIntentPopup/> */}
<ByMe/>
  </>
}

export default Wrapper;
